import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 490 490",
  style: {"enable-background":"new 0 0 490 490"},
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M490 245C490 109.9 380.1 0 245 0S0 109.9 0 245s109.9 245 245 245 245-109.9 245-245zm-455.7 0c0-116.2 94.5-210.7 210.7-210.7S455.7 128.8 455.7 245 361.2 455.7 245 455.7 34.3 361.2 34.3 245z" }, null, -1),
    _createElementVNode("path", { d: "m302.3 232.9-72.1-72.1c-6.7-6.7-17.6-6.7-24.3 0s-6.7 17.6 0 24.3l60 60-60 60c-6.7 6.7-6.7 17.6 0 24.3 3.3 3.3 7.7 5 12.1 5 4.4 0 8.8-1.7 12.1-5l72.1-72.1c6.8-6.9 6.8-17.7.1-24.4z" }, null, -1)
  ]))]))
}
export default { render };